import React, { Component } from 'react'
import './Graph.css'
import core from './core'
import graph from './d3'
import guardian from './../../images/guardian.png'
import parent from './../../images/parent.png'
import student from './../../images/student.png'

const nodeImage = {
  'parent': parent,
  'guardian': guardian,
  'student': student
}

class PersonGraph extends Component {
  componentDidMount = () => {
    this._bind(this.props)
  }

  componentWillReceiveProps = (nextProps) => {
    this._bind(nextProps)
  }

  _bind = (props) => {
    if (!props.data) return
    const { nodes, links } = core.convert(props.data)
    var options = {
      distance: 100,
      isLinkDescription: true,
      arrow: true,
      isZoom: true
    }
    if (props.options) options = props.options
    var filter = nodes.filter(x => x.type === undefined)
    for (let node of filter) {
      node.img = nodeImage[node.label.toLowerCase()]
    }
    graph.create(nodes, links, options)
  }

  render() {
    return (
      <div className="PersonGraph">
        <svg style={{ width: '100%', height: '100%' }}></svg>
      </div>
    )
  }
};

export default PersonGraph



// WEBPACK FOOTER //
// ./src/lib/components/Graph.js